import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  status: "idle",
  userProfileData: {},
};

export const getUserBasicData = createAsyncThunk(
  "userData/getUserBasicData",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get("user-basic-data");
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const userBasicDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    updateHeaderState: (state, action) => {
      state.userProfileData.logo_url = action.payload;
    },

    updatePreferenceList: (state, action) => {
      if (action.payload.type == "address") {
        state.userProfileData = {
          ...state.userProfileData,
          preference: {
            ...state.userProfileData.preference,
            [action.payload.type]: action.payload.data,
          },
        };
      }
      state.userProfileData[action.payload.type] = action.payload.data;
    },

    updateThemeState: (state, action) => {
      state.userProfileData.theme_class_name = action.payload;
    },

    updateSocialMedia: (state, action) => {
      state.userProfileData = {
        ...state.userProfileData,
        preference: {
          ...state.userProfileData.preference,
          social_media: [...action.payload],
        },
      };
    },

    updateTelephoneNumber: (state, action) => {
      state.userProfileData.preference.telephone_number = action.payload;
    },
  },
  extraReducers: {
    [getUserBasicData.pending]: (state, action) => {
      state.status = "loading";
      state.message = "";
    },
    [getUserBasicData.fulfilled]: (state, action) => {
      state.status = "succeed";
      state.userProfileData = action.payload.data.result;
    },
    [getUserBasicData.rejected]: (state, action) => {
      state.status = "error";
    },

    // [uploadWaterMarkLogo.pending]: (state, action) => {
    //   state.status = "loading";
    //   state.message = "";
    // },
    // [uploadWaterMarkLogo.fulfilled]: (state, action) => {
    //   state.status = "succeed";
    //   state.waterMarkData = action.payload.data.result;
    // },
    // [uploadWaterMarkLogo.rejected]: (state, action) => {
    //   state.status = "error";
    // },
    ["getStarted/uploadWaterMarkLogo/fulfilled"]: (state, action) => {
      state.userProfileData = {
        ...state.userProfileData,
        water_mark_url: action.payload.data.result.water_mark_url,
        preference: {
          ...state.userProfileData.preference,
          watermark_type: action?.meta?.arg?.type
        }

      }
    }
},
});

export const {
  updateHeaderState,
  updatePreferenceList,
  updateThemeState,
  updateSocialMedia,
  updateTelephoneNumber,
} = userBasicDataSlice.actions;

export default userBasicDataSlice.reducer;
